import React from "react";
import Header from "../components/header";
import Footer from "../components/footer";

function ContactPage() {
  return (
    <div>
      <Header />
      <h1>Welcome to my ContactPage</h1>
      <p>
        Check out my projects and get in touch if you're interested in working
        with me.
      </p>
      <Footer />
    </div>
  );
}

export default ContactPage;
